import type { AppointmentForm } from '@devexpress/dx-react-scheduler-material-ui';
import React from 'react';

import {
  Card,
  FilteredBackground,
  FlexContainer,
  OverlayContainer,
  InnerModal,
  OuterModal,
} from './Overlay.style';

/**
 * Modal for creating/editing/deleting routines
 */
const Overlay = ({ ...props }: AppointmentForm.OverlayProps) => {
  const { visible, children, onHide } = props;

  return visible ? (
    <OverlayContainer isOpen={visible}>
      <FilteredBackground
        onClick={onHide}
        style={{
          opacity: 1,
          transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        }}
      />
      <FlexContainer>
        <OuterModal width="auto">
          <Card padding="10px">
            <InnerModal>{children}</InnerModal>
          </Card>
        </OuterModal>
      </FlexContainer>
    </OverlayContainer>
  ) : (
    <div />
  );
};

export default Overlay;
